export default __webpack_public_path__ + "63cf0345495c2f3d38412ec05c2a6fa8.ico";